export enum KYC_STATUS {
	PENDING = "PENDING",
	UPLOADED_DOCUMENTS = "UPLOADED_DOCUMENTS",
	VERIFIED = "VERIFIED",
	STARTED = "STARTED",
  PENDING_REVALIDATION = "PENDING_REVALIDATION",
  REJECTED_PHOTO_ID = 'REJECTED_PHOTO_ID',
  REJECTED_ADDRESS_PROOF = 'REJECTED_ADDRESS_PROOF'
}
